module.exports = __webpack_public_path__ + "img/94_spicegirls.0b30897a.jpg";